export interface ChoiceShare {
  key: string;
  label: string;
  count: number;
  /** 0–100, of the runners who answered the question. */
  percent: number;
}

/** How a choice question's answers split: one bar per option, scaled to all who answered. */
export function ChoiceBars({
  options,
  answered,
  label,
  percentages = true,
}: {
  options: ChoiceShare[];
  answered: number;
  label: string;
  /** Off for a handful of answers, where a share says more than the counts behind it. */
  percentages?: boolean;
}) {
  return (
    <ul className="rq-bars" aria-label={label}>
      {options.map((o) => {
        const percent = Math.round(o.percent);
        const runners = `${o.count.toLocaleString('en-US')} of ${answered.toLocaleString('en-US')}`;
        return (
          <li key={o.key} className="rq-bars-row" title={`${o.label}: ${runners}, ${percent}%`}>
            <span className="rq-bars-label">{o.label}</span>
            <span className="rq-bars-track" aria-hidden="true">
              <span className="rq-bars-fill" style={{ width: `${Math.min(100, o.percent)}%` }} />
            </span>
            <span className="rq-bars-value">
              <span className="rq-sr">
                {runners} runners{percentages ? ', ' : ''}
              </span>
              <span aria-hidden="true">{o.count.toLocaleString('en-US')}</span>
              {percentages ? <span className="rq-bars-pct">{percent}%</span> : null}
            </span>
          </li>
        );
      })}
    </ul>
  );
}
